import React from 'react';
import { motion } from 'framer-motion';

export const FloatingDiya = ({ className = '' }) => {
  return (
    <motion.div
      className={`absolute pointer-events-none ${className}`}
      animate={{
        y: [0, -10, 0],
        rotate: [0, 5, -5, 0]
      }}
      transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }}
      aria-hidden="true"
    >
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Flame */}
        <motion.path
          d="M20 8 C22 12, 25 14, 25 18 C25 21, 23 23, 20 23 C17 23, 15 21, 15 18 C15 14, 18 12, 20 8 Z"
          fill="url(#diya-flame)"
          animate={{ opacity: [0.8, 1, 0.8] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        />
        {/* Diya bowl */}
        <ellipse cx="20" cy="26" rx="8" ry="3" fill="hsl(var(--lux-gold))" opacity="0.8" />
        <path
          d="M12 26 L10 30 Q20 34, 30 30 L28 26 Z"
          fill="hsl(var(--lux-bronze))"
          opacity="0.9"
        />
        <defs>
          <linearGradient id="diya-flame" x1="20" y1="8" x2="20" y2="23">
            <stop offset="0%" stopColor="#FFD700" stopOpacity="1" />
            <stop offset="50%" stopColor="#FFA500" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#FF6347" stopOpacity="0.7" />
          </linearGradient>
        </defs>
      </svg>
    </motion.div>
  );
};
